// extracted by mini-css-extract-plugin
export default {"content":"SingleLineData_content__4XahH","value":"SingleLineData_value__6b+b4"};